<script>
const APIServiceURL = 'http://www.searchplusplus.jp'
const port = 9090
export default {
  APIServiceURL,
  port
}
</script>
